import lodash from "lodash"
import { getAllXPathMappings, getXPathMapping } from "@/XVAT/XVATDataService"
import * as mutations from "./constants/mutation-types"
import * as getters from "./constants/getter-types"
import * as actions from "./constants/action-types"

export const xvat = {
  namespaced: true,
  state: {
    ruleSetRulesList: [],
    ruleCollectionRuleSetsList: [],
    addRulesFilters: {},
    addRuleSetsFilters: {},
    ruleQuickView: false,
    ruleCollectionRuleSets: [],

    // XPATH
    xpathMappingsList: [],
    xpathMappingsListLoading: false,
    xpathMappingKeysList: [],
    xpathMappingKeysListLoading: false,
    selectedXpathKey: {},
    showXpathDetails: false
  },
  mutations: {
    [mutations.SET_RULESET_RULES](state, value) {
      // added sequence for the rules
      lodash.forEach(value, (rule, index) => {
        rule["sequence"] = index
      })
      state.ruleSetRulesList = value
    },
    [mutations.SET_RULECOLLECTION_RULESETS](state, value) {
      // added sequence for the ruleSets
      lodash.forEach(value, (ruleSet, index) => {
        ruleSet["sequence"] = index
      })
      state.ruleCollectionRuleSetsList = value
    },
    [mutations.SET_ADD_RULES_FILTERS](state, value) {
      state.addRulesFilters = value
    },
    [mutations.SET_ADD_RULE_SETS_FILTERS](state, value) {
      state.addRuleSetsFilters = value
    },
    [mutations.SET_RULE_QUICK_VIEW](state, value) {
      state.ruleQuickView = value
    },
    [mutations.SET_XPATH_MAPPINGS_LIST](state, xpathMappingsListInput) {
      state.xpathMappingsList = xpathMappingsListInput
    },
    [mutations.SET_XPATH_MAPPINGS_LIST_LOADING](state, value) {
      state.xpathMappingsListLoading = value
    },
    [mutations.SET_XPATH_MAPPING_KEYS](state, value) {
      state.xpathMappingKeysList = value
    },
    [mutations.SET_XPATH_MAPPING_KEYS_LOADING](state, value) {
      state.xpathMappingKeysListLoading = value
    },
    [mutations.SET_SELECTED_XPATH_KEY](state, value) {
      state.selectedXpathKey = value
    },
    [mutations.SET_SHOW_XPATH_DETAILS](state, value) {
      state.showXpathDetails = value
    }
  },
  actions: {
    [actions.GET_XPATH_MAPPINGS_LIST](context) {
      if (!context.state.xpathMappingsListLoading) {
        context.commit(mutations.SET_XPATH_MAPPINGS_LIST_LOADING, true)
        return new Promise(resolve => {
          getAllXPathMappings().then(response => {
            context.commit(mutations.SET_XPATH_MAPPINGS_LIST_LOADING, false)
            context.commit(mutations.SET_XPATH_MAPPINGS_LIST, response.data.entries)
            resolve()
          })
        })
      } else {
        return new Promise(resolve => {
          resolve()
        })
      }
    },
    [actions.GET_XPATH_MAPPING_KEYS](context) {
      context.commit(mutations.SET_XPATH_MAPPING_KEYS_LOADING, true)
      return new Promise(resolve => {
        getXPathMapping().then(response => {
          let xpathKeysArray = response.data.entries
          let xpathKeysObjectArray = []
          if (!lodash.isUndefined(xpathKeysArray) && xpathKeysArray.length > 0) {
            lodash.forEach(xpathKeysArray, (value, index) => {
              xpathKeysObjectArray.push({ id: index, key: value })
            })
          }
          context.commit(mutations.SET_XPATH_MAPPING_KEYS, xpathKeysObjectArray)
          context.commit(mutations.SET_XPATH_MAPPING_KEYS_LOADING, false)
          resolve()
        }).catch(error => {
          context.commit(mutations.SET_XPATH_MAPPING_KEYS, [])
          context.commit(mutations.SET_XPATH_MAPPING_KEYS_LOADING, false)
          return Promise.reject(error)
        })
      })
    }
  },
  getters: {
    [getters.RULE_SET_HAS_RULES](state) {
      if (!lodash.isUndefined(state.ruleSetRulesList)) {
        return state.ruleSetRulesList.length > 0
      } else {
        return false
      }
    },
    [getters.RULE_COLLECTION_HAS_RULES_SETS](state) {
      if (!lodash.isUndefined(state.ruleCollectionRuleSetsList)) {
        return state.ruleCollectionRuleSetsList.length > 0
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/xvat.js